import React from 'react';
import ProjectCard from '../ProjectCard';
import { projectsData } from '../../data/projects';
import { useNavigate } from 'react-router-dom';

const ProjectsSection = () => {
    const navigate = useNavigate();

    const uniqueProjects = Array.from(
        new Map(projectsData.map(p => [p._id, p])).values()
    );
    const sortedProjects = uniqueProjects.sort((a, b) => b.priority - a.priority);
    const topProjects = sortedProjects.slice(0, 4);
    const remainingCount = Math.max(sortedProjects.length - 4, 0);

    return (
        <div className="relative px-4 lg:px-8 py-8">
            <div className="text-center mx-auto max-w-3xl mb-8">
                <h2 className="text-4xl font-bold text-gray-900 dark:text-white">
                    Projects
                </h2>
            </div>
            <div className="space-y-12">
                {topProjects.map((project, index) => (
                    <div
                        key={project._id}
                        className="sticky top-0 h-auto lg:h-screen flex items-center justify-center"
                        style={{ zIndex: index }}
                    >
                        <ProjectCard project={project} />
                    </div>
                ))}
            </div>
            {remainingCount > 0 && (
                <div className="flex justify-center mt-8">
                    <button
                        onClick={() => navigate('/projects')}
                        className="px-6 py-3 rounded-full bg-indigo-600 text-white dark:bg-indigo-500 dark:text-zinc-100 font-semibold shadow-md hover:bg-indigo-700 dark:hover:bg-indigo-600 transition"
                    >
                        View All Projects ({remainingCount} more)
                    </button>
                </div>
            )}
        </div>
    );
};

export default ProjectsSection;
